import { render, staticRenderFns } from "./login.vue?vue&type=template&id=0dfacf25&"
import script from "./login.ts?vue&type=script&lang=ts&"
export * from "./login.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports